var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('EntityTable',{attrs:{"name":"Entities","filterTitle":"Namespace","filterDefault":"admin","filterKeys":_vm.ns,"headers":_vm.entity_headers,"items":_vm.entities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }